import { reservation } from '../../services'

export const actions = {
  getReservation: reservation.actions.reservation.getReservation,
}
